import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from 'material-ui';
import { CheckDiffText } from '../../common/utils';

const LiftAndCranesView = ({ liftsCranes }) => {
    const items = React.useMemo(
        () => 
            Object.entries(liftsCranes).map(([key, value]) => ({
                ...value,
                name: key,
                label: `${key} mt:`,
            })), 
        [liftsCranes],
    );

    return (
        <React.Fragment>
            <div className='lift-and-cranes' style={{ margin: 'unset' }}>
                {items.map((liftCrane, index) => (
                    <LiftAndCranesItem
                        key={`${liftCrane.id || index}`}
                        liftCrane={liftCrane}
                    />
                ))}
            </div>
        </React.Fragment>
    );
};

LiftAndCranesView.propTypes = {
    liftsCranes: PropTypes.object.isRequired,
};

export default LiftAndCranesView;

const LiftAndCranesItem = ({ liftCrane }) => (
    <Fragment>
        <div className='line-head'>
            <div className='row'>
                <div className="col-xs-12 middle-xs">
                    <Checkbox
                        name={`liftsCranes.${liftCrane.name}.checked`}
                        label={liftCrane.label}
                        labelStyle={{ fontSize: '14px' }}
                        style={{ width: '750px' }}
                        disabled
                        checked={liftCrane.checked}
                    />
                </div>
            </div>
        </div>

        <div className='line-body'>
            {liftCrane.details.map((detail, index) => (
                <Fragment key={index}>
                    {(detail.status === 'new' || detail.status === 'normal') && (
                        <div className={detail.status === 'new' ? 'item middle-xs dirty-element' : 'item middle-xs '}>
                            <div className='count'>{detail ? detail.value : ''} mt</div>
                            <div className='name'>{detail ? detail.name : ''}</div>
                        </div>
                    )}

                    {detail.status === 'remove' && (
                        <div className='item middle-xs dirty-element'>
                            <div className='count'>
                                <CheckDiffText
                                    oldValue={detail ? detail.value : ''}
                                    newValue={null}
                                /> mt
                            </div>
                            <div className='name'>
                                <CheckDiffText
                                    oldValue={detail ? detail.name : ''}
                                    newValue={null}
                                />
                            </div>
                        </div>
                    )}

                    {detail.status === 'change' && (
                        <div className='item middle-xs dirty-element'>
                            <div className='count'>
                                <CheckDiffText
                                    oldValue={detail ? detail.value : ''}
                                    newValue={detail.changes.value ? detail.changes.value : ''}
                                /> mt
                            </div>
                            <div className='name'>
                                <CheckDiffText
                                    oldValue={detail ? detail.name : ''}
                                    newValue={detail.changes.name ? detail.changes.name : ''}
                                />
                            </div>
                        </div>
                    )}
                </Fragment>
            ))}
        </div>
    </Fragment>
);

LiftAndCranesItem.propTypes = {
    liftCrane: PropTypes.object,
    port: PropTypes.object,
    newPort: PropTypes.object,
};

LiftAndCranesItem.defaultProps = {
    liftCrane: {},
    port: {},
    newPort: {},
};



// WEBPACK FOOTER //
// ./app/components/Regions/PortManagement/blocks/LiftAndCranes/LiftAndCranesView.jsx